import {
  Button,
  Divider,
  ModalHeader,
  Alert,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  AlertIcon,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';

type ConvertAndLinkModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
};

export default function ConvertAndLinkModal({
  isOpen,
  onClose,
  onSubmit,
}: ConvertAndLinkModalProps): React.ReactElement {
  const [isSubmitting, setSubmitting] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);
  const onSubmitInternal = async () => {
    setSubmitting(true);
    try {
      await onSubmit();
    } catch (error) {
      console.error(
        'Error while converting to manually linked and linking elements'
      );
    }
    setSubmitting(false);
    onClose();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      size="lg"
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <ModalHeader>Convert link type to manual</ModalHeader>
        <Divider orientation="horizontal" />
        <AlertDialogBody marginX={2}>
          Are you sure you want to link the selected elements?
          <Alert mt={2} status="warning">
            <AlertIcon />
            The existing dynamic links will be converted to manual links in the
            process.
          </Alert>
        </AlertDialogBody>
        <Divider orientation="horizontal" />
        <AlertDialogFooter gap={2}>
          <Button
            onClick={onSubmitInternal}
            isLoading={isSubmitting}
            variant="outline"
            colorScheme="red"
          >
            Convert and link
          </Button>
          <Button colorScheme="gray" onClick={onClose}>
            Cancel
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
